
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import CreateApplicationModel from '@/models/applications/createApplicationModel';
import router from '@/router';
import ErrorCode from '@/constants/ErrorCode';
import UpdateApplicationStatusModel from '@/models/applications/updateApplicationStatusModel';
import ApplicationService from '../services/applicationService';

export default class Application extends Vue {
  private dialogVisible = false;

  private createApp = new CreateApplicationModel();

  private rules = {
    AppName: [
      {
        required: true,
        whitespace: true,
        message: '请输入应用名',
        trigger: 'blur',
      },
    ],
  };

  private appliactionList = [];

  mounted(): void {
    this.loadData();
  }

  async loadData(): Promise<void> {
    ApplicationService.getAll().then((response) => {
      if (response.code === ErrorCode.Success) {
        this.appliactionList = response.data;
      }
    });
  }

  del(id: string, name: string): void {
    const msg = `你确定要删除【${name}】应用?`;
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      ApplicationService.delete(id)
        .then((response) => {
          if (response.code === ErrorCode.Success) {
            ElMessage.success('删除成功!');
            this.loadData();
          } else {
            ElMessage.error(response.msg);
          }
        })
        .catch((response) => {
          ElMessage.error(response.msg);
        });
    });
  }

  save(): void {
    const form: any = this.$refs.createform;
    form.validate((valid: boolean) => {
      if (valid) {
        const loadingInstance = ElLoading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        ApplicationService.create(this.createApp).then((response) => {
          loadingInstance.close();
          if (response.code === ErrorCode.Success) {
            ElMessage.success(response.msg);
            this.loadData();
            form.resetFields();
            this.dialogVisible = false;
          } else {
            ElMessage.error(response.msg);
          }
        });
      }
    });
  }

  updateStatus(id: string, status: number, name: string): void {
    const msg = `你确定要${status === 0 ? '启用' : '禁用'}【${name}】应用?`;
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const model = new UpdateApplicationStatusModel();
      model.Status = status;
      ApplicationService.updateStatus(id, model)
        .then((response) => {
          if (response.code === ErrorCode.Success) {
            ElMessage.success(response.msg);
            this.loadData();
          } else {
            ElMessage.error(response.msg);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err && err.msg) {
            ElMessage.error(err.msg);
          } else {
            ElMessage.error('未知错误');
          }
        });
    });
  }

  opendetail(id: string): void {
    router.push({ path: `/application/${id}/applicationDetail` });
  }
  JumpAdd() {
    router.push('/AddApplication');
  }
}
